module.exports = __webpack_public_path__ + "media/images/icons/icons_large/36_candleholder-55a2d67551da7b048a9d0f9975050ed7.png";